import { z } from 'zod';
export const DateRangeSchema = z.object({
    start: z.string(),
    end: z.string()
});
/**
 * `amount` is nullable: the pre-compute layer reports `null` for "no in-scope payments to
 * average" rather than coercing to 0 (BAL-8163 B2), and that value is persisted verbatim. This
 * schema is on the READ path — backoffice-v2 parses every fetched analysis through it — so a
 * non-nullable `amount` would fail the parse for the whole analysis, not just this field.
 */ export const AvgTransactionValueSchema = z.object({
    amount: z.number().nullable(),
    currency: z.string()
});
export const SummaryMetricsSchema = z.object({
    critical_indicators: z.number(),
    patterns_requiring_review: z.number(),
    mismatches_identified: z.number()
});
export const MccInfoSchema = z.object({
    mcc: z.string(),
    description: z.string()
});
export const GeoBreakdownItemSchema = z.object({
    country: z.string(),
    percentage: z.number()
});
export const GeoDistributionSchema = z.object({
    primaryMarketCountry: z.string(),
    primaryMarketPercentage: z.number(),
    fullBreakdown: z.array(GeoBreakdownItemSchema)
});
export const TransactionMetricsSchema = z.object({
    numTransactions: z.number().nullish(),
    dateRange: DateRangeSchema.nullish(),
    avgTransactionValue: AvgTransactionValueSchema.nullish(),
    summaryMetrics: SummaryMetricsSchema.nullish(),
    processingMcc: MccInfoSchema.nullish(),
    suggestedMcc: MccInfoSchema.nullish(),
    geoDistribution: GeoDistributionSchema.nullish()
}).meta({
    id: 'TransactionMetrics'
});

//# sourceMappingURL=transaction-metrics.schema.js.map